import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 100 100" {...props}>
      <title>{props.title || 'Frame-Rotated'}</title>
      <g>
        <path d="M83.203 33.262l3.872 9.348h3.578l-.002 36.817H61.913L39.337 88.78H100V33.26zM0 38.235l67.02-27.76 21.24 51.29-67.014 27.76L0 38.236zM26.305 77.31l49.74-20.602L61.96 22.69 12.215 43.293l14.09 34.016z" />
      </g>
    </Icon>
  )
}
